// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"97510498","667":"00bc7af9","977":"bfad9f87"}[chunkId] + ".chunk.js";
};